var $ffda379ee377c118$exports = {};
// Voici le code pour animer la nav
const $ffda379ee377c118$var$nav = document.querySelector(".nav-bar");
const $ffda379ee377c118$var$navPanel = document.querySelector(".nav-panel");
const $ffda379ee377c118$var$contactLink = document.querySelector(".nav-panel ul li:nth-of-type(3)");
const $ffda379ee377c118$var$navIconBurger = document.querySelector(".nav-icon-burger");
// On crée une variable avec la dernière position de scroll
let $ffda379ee377c118$var$lastScrollPosition = 0;
// lorsqu'on scroll, la var currentScrollPosition est égal à notre valeur de scroll Y dans la fenetre
window.addEventListener("scroll", ()=>{
    let currentScrollPosition = window.scrollY;
    // Si currentScrollPosition est plus grand que lastScrollPosition, on  met la classe "scrolling-down" a header qui le cache dans le overflow. Sinon, on lui enleve la classe et il réapparait
    if (currentScrollPosition > $ffda379ee377c118$var$lastScrollPosition && currentScrollPosition > 100 && !$ffda379ee377c118$var$navPanel.classList.contains("nav-panel-shown")) $ffda379ee377c118$var$nav.classList.add("nav-scrolling-down");
    else $ffda379ee377c118$var$nav.classList.remove("nav-scrolling-down");
    // On assigne la valeur de currentScrollPosition a lastScrollPosition
    $ffda379ee377c118$var$lastScrollPosition = currentScrollPosition;
});
$ffda379ee377c118$var$contactLink.addEventListener("click", function() {
    $ffda379ee377c118$var$nav.classList.add("nav-scrolling-down");
    $ffda379ee377c118$var$navPanel.classList.remove("nav-panel-shown");
    $ffda379ee377c118$var$navIconBurger.classList.remove("nav-icon-burger-opened");
}); // cela permet d'avoir une nav qui n'est pas présente lorsque l'on scroll vers le bas


//# sourceMappingURL=index.b3c38020.js.map
